// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Common_wrap__32DFQ"};